import { makeStyles } from '@material-ui/styles';
import { MDSTypography, MDSButton } from '@marqvision/mds-v2';
import BgLoginPromotion from '~/assets/bg_login_page.png';
import CounterfeitProduct from '~/assets/counterfeit_product.svg?react';
import IllegalContent from '~/assets/illegal_content.svg?react';
import OnlineImpersonation from '~/assets/online_impersonation.svg?react';
import UnauthorizedSeller from '~/assets/unauthorized_seller.svg?react';
import { useLogger } from '~/hooks';
import { LeftPromotionInfoItem } from './LeftPromotionInfoItem';

const useStyles = makeStyles({
  bgLeftPromotion: {
    minHeight: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'flex-start',
    padding: '48px 72px',
    gap: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  textBox: {
    display: 'grid',
    gap: '6px',
  },
  infoBox: {
    display: 'inline-flex',
    gap: '24px',
  },
});

export const LeftPromotion = () => {
  const classes = useStyles();
  const { amplitudeLogging } = useLogger();

  const handleRefer = () => {
    // https://marqvision.atlassian.net/browse/PROD-8195
    window.open('https://www.marqvision.com/kr/refer-and-earn', '_blank', 'noopener,noreferrer');

    amplitudeLogging('clicked promotion banner', { On: 'Login' });
  };

  return (
    <div
      className={classes.bgLeftPromotion}
      style={{
        backgroundImage: `url(${BgLoginPromotion})`,
      }}
    >
      <div className={classes.textBox}>
        <MDSTypography variant="title" size="xl" color="color/content/on_default_color" weight="medium">
          Refer and Earn
        </MDSTypography>
        <MDSTypography variant="title" size="2xl" color="color/content/on_default_color" weight="semibold">
          국내외 온라인에서 어려움을 겪고 있는
          <br />
          브랜드를 소개하고 다양한 혜택을 제공 받으세요!
        </MDSTypography>
      </div>
      <div className={classes.infoBox}>
        <LeftPromotionInfoItem icon={<CounterfeitProduct />} label="위조상품" />
        <LeftPromotionInfoItem icon={<IllegalContent />} label="불법콘텐츠" />
        <LeftPromotionInfoItem icon={<OnlineImpersonation />} label="온라인사칭" />
        <LeftPromotionInfoItem icon={<UnauthorizedSeller />} label="비공식셀러" />
      </div>
      <MDSButton onClick={handleRefer} size="large">
        추천하기
      </MDSButton>
    </div>
  );
};
